<template>
  <div class="login-wrap">
    <!-- 白色主容器卡片 -->
    <div class="login-main">
      <!-- 顶部header -->
      <div class="login-header">
        <div class="logo-left">
          <img :src="`${publicPath}logo.png`" class="logo-icon-img" alt="蜜蜂公社">
          <span class="logo-text">{{ systemName }}</span>
        </div>
        <div class="header-right">
          <span>城市运营商登录 ▾</span>
          <span>帮助</span>
        </div>
      </div>

      <!-- 中间主体：左logo 右表单 -->
      <div class="login-body">
        <div class="body-left">
          <div class="big-logo">
            <img :src="`${publicPath}logo-big.png`" class="big-logo-img" alt="蜜蜂公社LOGO">
          </div>
        </div>

        <div class="body-right">
          <div class="form-top">
            <h2>城市运营商后台登录</h2>
            <p class="blue-desc">运营商管理控制台</p>
            <p class="gray-tip">请输入您的运营商账号和密码，登录系统</p>
          </div>

          <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" label-width="0" @keyup.enter.native="submitLogin">
            <!-- 用户名 -->
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入运营商用户名"
                prefix-icon="el-icon-user-solid"
                size="large"
              ></el-input>
            </el-form-item>

            <!-- 密码 + 验证码 同一行 -->
            <div class="pwd-captcha-row">
              <el-form-item prop="password" class="pwd-item">
                <el-input
                  v-model="loginForm.password"
                  type="password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                  size="large"
                  @keyup.enter.native="submitLogin"
                ></el-input>
              </el-form-item>

              <el-form-item prop="captcha" class="captcha-item">
                <el-input
                  v-model="loginForm.captcha"
                  placeholder="验证码"
                  size="large"
                >
                  <template slot="append">
                    <div class="captcha-img" @click="refreshCaptcha" v-loading="captchaLoading">
                      <img v-if="captchaImage" :src="captchaImage" alt="验证码" class="captcha-real-img">
                      <span v-else>点击刷新</span>
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <!-- 记住密码 + 忘记密码 -->
            <div class="form-row-two">
              <el-checkbox v-model="loginForm.rememberPwd">记住密码</el-checkbox>
              <span class="forget-pwd">忘记密码？</span>
            </div>

            <!-- 登录按钮 -->
            <el-form-item>
              <el-button type="primary" class="login-btn" size="large" @click="submitLogin" :loading="loading">立即登录</el-button>
            </el-form-item>

            <!-- 申请开通运营商链接 -->
            <div class="apply-link-box">
              <span class="apply-link" @click="showApplyDialog = true">
                <i class="el-icon-plus"></i> 申请开通运营商
              </span>
            </div>
          </el-form>

          <div class="login-footer">
            <div class="footer-info">
              <i class="el-icon-info"></i>
              <span>城市运营商专用入口</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 申请开通运营商对话框 -->
    <el-dialog
      title="申请开通运营商"
      :visible.sync="showApplyDialog"
      width="700px"
      :close-on-click-modal="false"
      @close="resetApplyForm"
    >
      <el-form :model="applyForm" :rules="applyRules" ref="applyFormRef" label-width="120px">
        <!-- 第一步：证件上传（智能识别） -->
        <el-divider content-position="left"><i class="el-icon-magic-stick" style="color: #ff6b35;"></i> 智能识别证件信息</el-divider>
        
        <div class="ocr-upload-section">
          <el-form-item label="营业执照" prop="businessLicense">
            <div class="ocr-upload-box">
              <el-upload
                class="license-uploader"
                action="/api/upload/image"
                :show-file-list="false"
                :on-success="handleLicenseSuccess"
                :before-upload="beforeImageUpload"
                accept="image/*"
              >
                <img v-if="applyForm.businessLicense" :src="applyForm.businessLicense" class="license-image">
                <div v-else class="uploader-placeholder">
                  <i class="el-icon-plus"></i>
                  <span>点击上传营业执照</span>
                  <small>支持 JPG、PNG 格式</small>
                </div>
              </el-upload>
              <div v-if="ocrStatus.license === 'loading'" class="ocr-loading">
                <i class="el-icon-loading"></i> 正在识别营业执照信息...
              </div>
              <div v-if="ocrStatus.license === 'success'" class="ocr-success">
                <i class="el-icon-check"></i> 识别成功，已自动填充企业信息
              </div>
            </div>
          </el-form-item>

          <el-form-item label="法人身份证" prop="idCardImages">
            <div class="ocr-upload-box">
              <div class="idcard-upload-wrapper">
                <el-upload
                  class="idcard-uploader"
                  action="/api/upload/image"
                  :show-file-list="false"
                  :on-success="handleIdCardFrontSuccess"
                  :before-upload="beforeImageUpload"
                  accept="image/*"
                >
                  <img v-if="applyForm.idCardFront" :src="applyForm.idCardFront" class="idcard-image">
                  <div v-else class="uploader-placeholder">
                    <i class="el-icon-plus"></i>
                    <span>身份证正面</span>
                  </div>
                </el-upload>
                <el-upload
                  class="idcard-uploader"
                  action="/api/upload/image"
                  :show-file-list="false"
                  :on-success="handleIdCardBackSuccess"
                  :before-upload="beforeImageUpload"
                  accept="image/*"
                >
                  <img v-if="applyForm.idCardBack" :src="applyForm.idCardBack" class="idcard-image">
                  <div v-else class="uploader-placeholder">
                    <i class="el-icon-plus"></i>
                    <span>身份证反面</span>
                  </div>
                </el-upload>
              </div>
              <div v-if="ocrStatus.idCard === 'loading'" class="ocr-loading">
                <i class="el-icon-loading"></i> 正在识别身份证信息...
              </div>
              <div v-if="ocrStatus.idCard === 'success'" class="ocr-success">
                <i class="el-icon-check"></i> 识别成功，已自动填充法人信息
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 第二步：自动填充的企业信息 -->
        <el-divider content-position="left">企业信息（自动填充，可修改）</el-divider>

        <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="applyForm.companyName" placeholder="上传营业执照后自动识别">
            <i v-if="applyForm.companyName" slot="suffix" class="el-icon-check" style="color: #67c23a;"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="统一社会信用代码" prop="creditCode">
          <el-input v-model="applyForm.creditCode" placeholder="上传营业执照后自动识别">
            <i v-if="applyForm.creditCode" slot="suffix" class="el-icon-check" style="color: #67c23a;"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="法人姓名" prop="legalPerson">
          <el-input v-model="applyForm.legalPerson" placeholder="上传身份证后自动识别">
            <i v-if="applyForm.legalPerson" slot="suffix" class="el-icon-check" style="color: #67c23a;"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="所在地区" prop="region">
          <el-cascader
            v-model="applyForm.region"
            :options="regionOptions"
            placeholder="注册地址所在地区"
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="applyForm.address" type="textarea" rows="2" placeholder="详细经营地址"></el-input>
        </el-form-item>

        <!-- 第三步：联系人信息 -->
        <el-divider content-position="left">联系人信息</el-divider>

        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="applyForm.contactName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="applyForm.contactPhone" placeholder="请输入联系人手机号"></el-input>
        </el-form-item>

        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="applyForm.email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>

        <el-form-item label="补充说明">
          <el-input
            v-model="applyForm.remark"
            type="textarea"
            rows="3"
            placeholder="如有其他需要说明的情况，请在此填写"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showApplyDialog = false; resetApplyForm();">取消</el-button>
        <el-button type="primary" @click="submitApply" :loading="applyLoading" icon="el-icon-check">提交申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

// 创建登录专用 axios 实例（使用相对路径，通过 Nginx 反向代理）
const loginRequest = axios.create({
  baseURL: '/api',
  timeout: 30000,
  withCredentials: true
})

export default {
  name: "OperatorLogin",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      systemName: "蜂巢e社区-CY",
      loginForm: {
        username: "",
        password: "",
        captcha: "",
        rememberPwd: false
      },
      loginRules: {
        username: [{required: true, message: "请输入用户名", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        captcha: [{required: true, message: "请输入验证码", trigger: "blur"}]
      },
      loading: false,
      captchaImage: "",
      captchaLoading: false,
      // 申请开通运营商
      showApplyDialog: false,
      applyLoading: false,
      ocrStatus: {
        license: '', // 'loading' | 'success' | ''
        idCard: ''   // 'loading' | 'success' | ''
      },
      applyForm: {
        companyName: '',
        creditCode: '',
        legalPerson: '',
        region: [],
        address: '',
        contactName: '',
        contactPhone: '',
        email: '',
        businessLicense: '',
        idCardFront: '',
        idCardBack: '',
        remark: ''
      },
      applyRules: {
        companyName: [{ required: true, message: '请上传营业执照自动识别', trigger: 'blur' }],
        creditCode: [{ required: true, message: '请上传营业执照自动识别', trigger: 'blur' }],
        legalPerson: [{ required: true, message: '请上传身份证自动识别', trigger: 'blur' }],
        region: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        contactName: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        businessLicense: [{ required: true, message: '请上传营业执照', trigger: 'change' }]
      },
      regionOptions: [
        { value: '北京市', label: '北京市', children: [{ value: '北京市', label: '北京市', children: [{ value: '朝阳区', label: '朝阳区' }, { value: '海淀区', label: '海淀区' }, { value: '东城区', label: '东城区' }, { value: '西城区', label: '西城区' }, { value: '丰台区', label: '丰台区' }, { value: '石景山区', label: '石景山区' }, { value: '门头沟区', label: '门头沟区' }, { value: '房山区', label: '房山区' }, { value: '通州区', label: '通州区' }, { value: '顺义区', label: '顺义区' }, { value: '昌平区', label: '昌平区' }, { value: '大兴区', label: '大兴区' }, { value: '怀柔区', label: '怀柔区' }, { value: '平谷区', label: '平谷区' }, { value: '密云区', label: '密云区' }, { value: '延庆区', label: '延庆区' }] }] },
        { value: '上海市', label: '上海市', children: [{ value: '上海市', label: '上海市', children: [{ value: '黄浦区', label: '黄浦区' }, { value: '徐汇区', label: '徐汇区' }, { value: '长宁区', label: '长宁区' }, { value: '静安区', label: '静安区' }, { value: '普陀区', label: '普陀区' }, { value: '虹口区', label: '虹口区' }, { value: '杨浦区', label: '杨浦区' }, { value: '浦东新区', label: '浦东新区' }, { value: '闵行区', label: '闵行区' }, { value: '宝山区', label: '宝山区' }, { value: '嘉定区', label: '嘉定区' }, { value: '金山区', label: '金山区' }, { value: '松江区', label: '松江区' }, { value: '青浦区', label: '青浦区' }, { value: '奉贤区', label: '奉贤区' }, { value: '崇明区', label: '崇明区' }] }] },
        { value: '广东省', label: '广东省', children: [{ value: '广州市', label: '广州市', children: [{ value: '越秀区', label: '越秀区' }, { value: '荔湾区', label: '荔湾区' }, { value: '海珠区', label: '海珠区' }, { value: '天河区', label: '天河区' }, { value: '白云区', label: '白云区' }, { value: '黄埔区', label: '黄埔区' }, { value: '番禺区', label: '番禺区' }, { value: '花都区', label: '花都区' }, { value: '南沙区', label: '南沙区' }, { value: '从化区', label: '从化区' }, { value: '增城区', label: '增城区' }] }, { value: '深圳市', label: '深圳市', children: [{ value: '罗湖区', label: '罗湖区' }, { value: '福田区', label: '福田区' }, { value: '南山区', label: '南山区' }, { value: '宝安区', label: '宝安区' }, { value: '龙岗区', label: '龙岗区' }, { value: '盐田区', label: '盐田区' }, { value: '龙华区', label: '龙华区' }, { value: '坪山区', label: '坪山区' }, { value: '光明区', label: '光明区' }] }] },
        { value: '浙江省', label: '浙江省', children: [{ value: '杭州市', label: '杭州市', children: [{ value: '上城区', label: '上城区' }, { value: '下城区', label: '下城区' }, { value: '江干区', label: '江干区' }, { value: '拱墅区', label: '拱墅区' }, { value: '西湖区', label: '西湖区' }, { value: '滨江区', label: '滨江区' }, { value: '萧山区', label: '萧山区' }, { value: '余杭区', label: '余杭区' }, { value: '富阳区', label: '富阳区' }, { value: '临安区', label: '临安区' }, { value: '桐庐县', label: '桐庐县' }, { value: '淳安县', label: '淳安县' }, { value: '建德市', label: '建德市' }] }] },
        { value: '江苏省', label: '江苏省', children: [{ value: '南京市', label: '南京市', children: [{ value: '玄武区', label: '玄武区' }, { value: '秦淮区', label: '秦淮区' }, { value: '建邺区', label: '建邺区' }, { value: '鼓楼区', label: '鼓楼区' }, { value: '浦口区', label: '浦口区' }, { value: '栖霞区', label: '栖霞区' }, { value: '雨花台区', label: '雨花台区' }, { value: '江宁区', label: '江宁区' }, { value: '六合区', label: '六合区' }, { value: '溧水区', label: '溧水区' }, { value: '高淳区', label: '高淳区' }] }] },
        { value: '四川省', label: '四川省', children: [{ value: '成都市', label: '成都市', children: [{ value: '锦江区', label: '锦江区' }, { value: '青羊区', label: '青羊区' }, { value: '金牛区', label: '金牛区' }, { value: '武侯区', label: '武侯区' }, { value: '成华区', label: '成华区' }, { value: '龙泉驿区', label: '龙泉驿区' }, { value: '青白江区', label: '青白江区' }, { value: '新都区', label: '新都区' }, { value: '温江区', label: '温江区' }, { value: '双流区', label: '双流区' }, { value: '郫都区', label: '郫都区' }, { value: '新津区', label: '新津区' }, { value: '金堂县', label: '金堂县' }, { value: '大邑县', label: '大邑县' }, { value: '蒲江县', label: '蒲江县' }, { value: '都江堰市', label: '都江堰市' }, { value: '彭州市', label: '彭州市' }, { value: '邛崃市', label: '邛崃市' }, { value: '崇州市', label: '崇州市' }, { value: '简阳市', label: '简阳市' }] }] }
      ]
    };
  },
  mounted() {
    this.refreshCaptcha();

    // 已登录用户直接跳转首页（路由守卫也会处理）
    // 这里不需要额外处理，避免重复跳转
  },
  methods: {
    // 获取后端验证码
    async refreshCaptcha() {
      this.captchaLoading = true;
      try {
        // 使用 axios 直接请求后端
        const res = await loginRequest.get('/common/captcha/generate')
        console.log('验证码接口返回:', res);
        // 兼容字符串和布尔值两种返回格式
        if (res.data.success === 'true' || res.data.success === true) {
          this.captchaImage = res.data.captchaImage;
        } else {
          this.$message.error(res.data.message || '验证码加载失败');
        }
      } catch (error) {
        console.error('获取验证码失败:', error);
        this.$message.error('验证码加载失败，请检查后端服务是否启动');
      } finally {
        this.captchaLoading = false;
        this.loginForm.captcha = '';
      }
    },

    submitLogin() {
      this.$refs.loginFormRef.validate(valid => {
        if(!valid) return;

        this.loading = true;

        // 使用 axios 直接请求后端（表单格式）
        const params = new URLSearchParams();
        params.append('username', this.loginForm.username);
        params.append('password', this.loginForm.password);
        params.append('captcha', this.loginForm.captcha);
        
        loginRequest.post('/admin/cityOperator/login', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(res => {
          this.loading = false;
          // 兼容两种返回格式：success 或 code: 0
          const isSuccess = res.data.success || res.data.code === 0;
          if (isSuccess) {
            // 登录成功
            localStorage.setItem('isLogin', 'true');
            localStorage.setItem('username', this.loginForm.username);
            localStorage.setItem('userType', 'cityOperator');
            localStorage.setItem('cityOperatorId', res.data.operatorId || res.data.data?.id || res.data.data?.operatorId);
            localStorage.setItem('cityOperatorName', res.data.operatorName || res.data.data?.companyName || res.data.data?.operatorName);
            // 存储token（如果有）
            if (res.data.token) {
              localStorage.setItem('token', res.data.token);
            }
            // 存储数据隔离ID
            const d = res.data.data || {};
            localStorage.setItem('platformId', d.platformId || '1');
            localStorage.setItem('cityId', d.cityId || '');
            localStorage.setItem('cityName', d.city || '');
            localStorage.setItem('groupId', d.groupId || '');
            localStorage.setItem('propertyId', d.propertyId || '');

            // 登录后设置后端 session 属性（让 JwtOperatorFilter/OperatorAuthFilter 能识别）
            // 必须等待 setup-session 完成再跳转，否则社区/物业等页面加载时 session 没设上
            const doRedirect = () => {
              this.$message.success("登录成功，欢迎回来！");
              this.$router.push('/operator/dashboard');
            }
            const operatorId = localStorage.getItem('cityOperatorId')
            if (operatorId) {
              loginRequest.post('/operator/auth/setup-session', { operatorId: parseInt(operatorId) })
                .then(() => doRedirect())
                .catch(() => {
                  console.warn('setup-session failed, non-critical')
                  doRedirect()
                })
            } else {
              doRedirect()
            }
          } else {
            this.$message.error(res.data.message || "用户名或密码错误");
            this.refreshCaptcha();
          }
        })
        .catch(err => {
          this.loading = false;
          console.error('登录请求失败:', err);
          this.$message.error("登录请求失败，请检查服务器");
          this.refreshCaptcha();
        });
      });
    },

    // 营业执照上传成功 - 触发OCR识别
    handleLicenseSuccess(res) {
      if (res.code === 200) {
        this.applyForm.businessLicense = res.data.url;
        this.$message.success('营业执照上传成功');
        // 触发OCR识别
        this.recognizeLicense(res.data.url);
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    // 身份证正面上传成功 - 检查是否两面都上传完成
    handleIdCardFrontSuccess(res) {
      if (res.code === 200) {
        this.applyForm.idCardFront = res.data.url;
        this.$message.success('身份证正面上传成功');
        // 如果反面也上传了，触发OCR识别
        if (this.applyForm.idCardBack) {
          this.recognizeIdCard();
        }
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    // 身份证反面上传成功 - 检查是否两面都上传完成
    handleIdCardBackSuccess(res) {
      if (res.code === 200) {
        this.applyForm.idCardBack = res.data.url;
        this.$message.success('身份证反面上传成功');
        // 如果正面也上传了，触发OCR识别
        if (this.applyForm.idCardFront) {
          this.recognizeIdCard();
        }
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    // OCR识别营业执照
    async recognizeLicense(imageUrl) {
      this.ocrStatus.license = 'loading';
      try {
        // 调用后端OCR接口
        const res = await loginRequest.post('/common/ocr/license', {
          imageUrl: imageUrl
        });
        
        if (res.data.success) {
          const data = res.data.data;
          // 自动填充识别结果
          if (data.companyName) {
            this.applyForm.companyName = data.companyName;
          }
          if (data.creditCode) {
            this.applyForm.creditCode = data.creditCode;
          }
          if (data.legalPerson) {
            this.applyForm.legalPerson = data.legalPerson;
          }
          if (data.address) {
            this.applyForm.address = data.address;
          }
          this.ocrStatus.license = 'success';
          this.$message.success('营业执照识别成功，已自动填充企业信息');
        } else {
          // 识别失败但不上报错误，让用户手动填写
          this.ocrStatus.license = '';
          this.$message.warning('自动识别未完成，请手动填写企业信息');
        }
      } catch (error) {
        console.error('营业执照OCR识别失败:', error);
        this.ocrStatus.license = '';
        // 模拟识别成功（演示模式）
        this.simulateLicenseRecognition();
      }
    },
    // 模拟营业执照识别（演示用）
    simulateLicenseRecognition() {
      setTimeout(() => {
        this.applyForm.companyName = '示例科技有限公司';
        this.applyForm.creditCode = '91110108MA00XXXXXX';
        this.applyForm.legalPerson = '';
        this.applyForm.address = '北京市海淀区中关村大街1号';
        this.applyForm.region = ['北京市', '北京市', '海淀区'];
        this.ocrStatus.license = 'success';
        this.$message.success('营业执照识别成功，已自动填充企业信息');
      }, 1500);
    },
    // OCR识别身份证
    async recognizeIdCard() {
      this.ocrStatus.idCard = 'loading';
      try {
        // 调用后端OCR接口
        const res = await loginRequest.post('/common/ocr/idcard', {
          frontImageUrl: this.applyForm.idCardFront,
          backImageUrl: this.applyForm.idCardBack
        });
        
        if (res.data.success) {
          const data = res.data.data;
          // 自动填充识别结果
          if (data.name) {
            this.applyForm.legalPerson = data.name;
          }
          if (data.address) {
            // 可以提取地址信息
          }
          this.ocrStatus.idCard = 'success';
          this.$message.success('身份证识别成功');
        } else {
          this.ocrStatus.idCard = '';
          this.$message.warning('身份证识别未完成，请手动填写');
        }
      } catch (error) {
        console.error('身份证OCR识别失败:', error);
        this.ocrStatus.idCard = '';
        // 模拟识别成功（演示模式）
        this.simulateIdCardRecognition();
      }
    },
    // 模拟身份证识别（演示用）
    simulateIdCardRecognition() {
      setTimeout(() => {
        if (!this.applyForm.legalPerson) {
          this.applyForm.legalPerson = '';
        }
        this.ocrStatus.idCard = 'success';
        this.$message.success('身份证识别成功');
      }, 1500);
    },
    // 重置申请表单
    resetApplyForm() {
      this.ocrStatus = {
        license: '',
        idCard: ''
      };
      this.applyForm = {
        companyName: '',
        creditCode: '',
        legalPerson: '',
        region: [],
        address: '',
        contactName: '',
        contactPhone: '',
        email: '',
        businessLicense: '',
        idCardFront: '',
        idCardBack: '',
        remark: ''
      };
      if (this.$refs.applyFormRef) {
        this.$refs.applyFormRef.resetFields();
      }
    },
    // 图片上传前检查
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('请上传图片文件');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB');
        return false;
      }
      return true;
    },
    // 提交申请
    submitApply() {
      this.$refs.applyFormRef.validate(valid => {
        if (!valid) return;

        if (!this.applyForm.idCardFront || !this.applyForm.idCardBack) {
          this.$message.warning('请上传法人身份证正反面照片');
          return;
        }

        this.applyLoading = true;

        // 组装提交数据
        const submitData = {
          companyName: this.applyForm.companyName,
          creditCode: this.applyForm.creditCode,
          legalPerson: this.applyForm.legalPerson,
          province: this.applyForm.region[0],
          city: this.applyForm.region[1],
          district: this.applyForm.region[2],
          address: this.applyForm.address,
          contactName: this.applyForm.contactName,
          contactPhone: this.applyForm.contactPhone,
          email: this.applyForm.email,
          businessLicense: this.applyForm.businessLicense,
          idCardFront: this.applyForm.idCardFront,
          idCardBack: this.applyForm.idCardBack,
          remark: this.applyForm.remark
        };

        // 调用后端接口提交申请
        loginRequest.post('/admin/cityOperator/apply', submitData)
          .then(res => {
            this.applyLoading = false;
            if (res.data.success) {
              this.$message.success('申请提交成功，我们会尽快审核并联系您！');
              this.showApplyDialog = false;
              // 重置表单
              this.resetApplyForm();
            } else {
              this.$message.error(res.data.message || '申请提交失败');
            }
          })
          .catch(err => {
            this.applyLoading = false;
            console.error('申请提交失败:', err);
            this.$message.error('申请提交失败，请稍后重试');
          });
      });
    }
  }
};
</script>

<style scoped>
/* 全局铺满 - 白色背景 */
.login-wrap {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background: #fff;
}

/* 白色主容器 - 铺满整个页面 */
.login-main {
  width: 100%;
  height: 100%;
  background: #fff;
}

/* 顶部头部 */
.login-header {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  border-bottom: 1px solid #eee;
  background: #fff;
  overflow: visible;
  position: relative;
  z-index: 10;
}
.logo-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  overflow: visible;
}
.logo-icon-img {
  height: 55px;
  width: auto;
  object-fit: contain;
}
.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-left: 10px;
  white-space: nowrap;
}
.header-right {
  display: flex;
  gap: 30px;
  font-size: 14px;
  color: #666;
}
.header-right span {
  cursor: pointer;
  transition: color 0.3s;
}
.header-right span:hover {
  color: #ff6b35;
}

/* 中间主体 flex布局 */
.login-body {
  display: flex;
  width: 100%;
  height: calc(100% - 70px);
  align-items: center;
  padding: 0 60px;
}

/* 左侧大logo区域 */
.body-left {
  flex: 1;
  display: flex;
  justify-content: center;
}
.big-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.big-logo-img {
  max-width: 800px;
  height: auto;
  object-fit: contain;
}

/* 右侧表单 */
.body-right {
  width: 450px;
}
.form-top h2 {
  font-size: 28px;
  color: #222;
  margin: 0 0 10px;
  font-weight: 600;
}
.blue-desc {
  color: #ff6b35;
  font-size: 15px;
  margin: 0 0 5px;
  font-weight: 500;
}
.gray-tip {
  color: #999;
  font-size: 13px;
  margin-bottom: 35px;
}

/* 密码+验证码同行 */
.pwd-captcha-row {
  display: flex;
  gap: 0;
}
.pwd-item {
  flex: 1.5;
  margin-bottom: 0 !important;
}
.captcha-item {
  flex: 0 0 260px;
  margin-bottom: 0 !important;
}
.captcha-item ::v-deep .el-input__inner {
  width: 100% !important;
  border-radius: 4px 0 0 4px !important;
}
.captcha-item ::v-deep .el-input-group__append {
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}
.captcha-img {
  cursor: pointer;
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 0 4px 4px 0;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  border-left: none;
}
.captcha-real-img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.form-row-two {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin: 20px 0 30px;
}
.forget-pwd {
  color: #ff6b35;
  cursor: pointer;
  transition: color 0.3s;
}
.forget-pwd:hover {
  color: #ff8c5a;
}

.login-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg, #ff8c5a 0%, #ff6b35 100%);
  border: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  box-shadow: 0 5px 15px rgba(255, 107, 53, 0.3);
  transition: all 0.3s;
}
.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 107, 53, 0.4);
}
.login-btn:active {
  transform: translateY(0);
}

/* 申请开通运营商链接 - 放在登录按钮下方 */
.apply-link-box {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
  display: block;
}
.apply-link-box .apply-link {
  color: #ff6b35;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}
.apply-link-box .apply-link:hover {
  color: #ff8c5a;
  text-decoration: underline;
}
.apply-link-box .apply-link i {
  margin-right: 4px;
}

.login-footer {
  margin-top: 25px;
  font-size: 13px;
  color: #999;
  text-align: center;
}
.footer-links {
  margin-bottom: 12px;
  display: block;
}
.apply-link {
  color: #ff6b35;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}
.apply-link:hover {
  color: #ff8c5a;
  text-decoration: underline;
}
.apply-link i {
  margin-right: 4px;
}
.footer-info i {
  margin-right: 5px;
}

/* 申请开通运营商对话框样式 */
.ocr-upload-section {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.ocr-upload-box {
  position: relative;
}

.ocr-loading {
  margin-top: 10px;
  padding: 8px 12px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  color: #409eff;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ocr-success {
  margin-top: 10px;
  padding: 8px 12px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  color: #67c23a;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.license-uploader ::v-deep .el-upload {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 280px;
  height: 180px;
  background: #fff;
  transition: all 0.3s;
}

.license-uploader ::v-deep .el-upload:hover {
  border-color: #ff6b35;
  background: #fff8f5;
}

.license-uploader .uploader-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
}

.license-uploader .uploader-placeholder i {
  font-size: 32px;
  margin-bottom: 10px;
  color: #c0c4cc;
}

.license-uploader .uploader-placeholder span {
  font-size: 14px;
  margin-bottom: 6px;
}

.license-uploader .uploader-placeholder small {
  font-size: 12px;
  color: #c0c4cc;
}

.license-uploader .license-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.idcard-upload-wrapper {
  display: flex;
  gap: 20px;
}

.idcard-uploader ::v-deep .el-upload {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 125px;
  background: #fff;
  transition: all 0.3s;
}

.idcard-uploader ::v-deep .el-upload:hover {
  border-color: #ff6b35;
  background: #fff8f5;
}

.idcard-uploader .uploader-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
}

.idcard-uploader .uploader-placeholder i {
  font-size: 24px;
  margin-bottom: 6px;
  color: #c0c4cc;
}

.idcard-uploader .uploader-placeholder span {
  font-size: 13px;
}

.idcard-uploader .idcard-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .big-logo-img {
    max-width: 500px;
  }
}
</style>
